import { db } from "@/firebase";
import Store from "./../index";

const OrganisationStore = {
  state: {
    organisations: null
  },

  mutations: {
    SET_ORGANISATIONS(state, organisations) {
      state.organisations = organisations;
    },
    ADD_ORGANISATION(state, params) {
      console.log(params)
      params.organisation.id = params.ref.id;
      state.organisations.unshift(params.organisation);
    },
    UPDATE_ORGANISATION(state, params) {
      state.organisations[params.organisation.index] = params.organisation
    },
    DELETE_ORGANISATION(state, organisation) {
      state.organisations.splice(state.organisations.indexOf(organisation), 1);
    }
  },

  getters: {
    organisations: state => state.organisations,
    organisationById: state => id => {
      if (state.organisations){
        return state.organisations.filter(organisation => {
          return organisation.id === id;
        })[0];
      }
    },
  },

  actions: {
    getOrganisations({ commit }) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .get()
          .then(
            querySnapshot => {
              let data = []
              querySnapshot.forEach(function(org) {
                db.collection('organisations')
                  .doc(org.id)
                  .collection('meta')
                  .doc('company')
                  .get()
                  .then(
                    doc => {
                      let obj = doc.data()
                      obj.id = org.id
                      data.push(obj);
                    },
                    error => {
                      reject(error);
                    }
                  )
              });
              commit("SET_ORGANISATIONS", data);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    addOrganisation ({commit}, organisation) {
      return new Promise((resolve, reject) => {
        db.collection('organisations').add({})
          .then(function(ref) {
            ref.collection('meta')
              .doc('theming')
              .set({ colorTheme: {}, colorInvoiceTheme: {} })
              .then( function () {
                ref.collection('meta')
                  .doc('company')
                  .set(organisation.meta.company)
                  .then(function () {
                    commit("ADD_ORGANISATION", {ref: ref, organisation: organisation});
                    resolve(organisation)
                  })
                  .catch(function (error) {
                    reject(error);
                  });
              })
          })
      });
    },
    updateOrganisation ({commit}, organisation) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("organisations")
          .doc(organisation.id)
          .set(organisation)
          .then(function () {
            commit("UPDATE_ORGANISATION", {organisation: organisation});
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
    deleteOrganisation ({commit}, organisation) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("organisations")
          .doc(organisation.id)
          .delete()
          .then(function () {
            commit("DELETE_ORGANISATION", organisation);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
  }
};

export default OrganisationStore;
